<template>
  <div>
    <div class="main show-on-desktop">
      <div>
        <p class="rechner_title">WHAT IS RESOURCE <br>OPTIMISATION ALL ABOUT?</p>
        <br />
        <p class="rechner_teaser">
          <b>DEIN RAUM</b> enables you to gain an insight into the utilisation of your workplaces and to realise potential savings through qualified analyses. With our savings calculator, you can quickly work out how much money your company can save with <b>DEIN RAUM</b>:
        </p>
        <div>
          <p class="warningMsg" v-if="showMessage">
            ** Please fill in all fields!
          </p>
        </div>
      </div>
      <div>
        <div class="justify-content-center">
          <div class="inputItem px-0 my-4">
            <label for="numemployee" class="lbl clear"
              >Number of employees<sup>*</sup></label
            >
            <input id="numemployee" type="number" v-model="mitarbeiter" />
          </div>
          <div class="inputItem px-0 my-4">
            <label for="fleache" class="lbl clear"
              >Office space in <b> m²</b></label
            >
            <input id="fleache" type="number" v-model="beurofleache" />
          </div>

          <div class="inputItem px-0 my-4">
            <label for="kosten" class="lbl clear"
              >Costs per <b> m² </b>in <b>€</b><sup>*</sup></label
            >
            <input
              id="kosten"
              type="number"
              v-model="kosten"
              @keyup.enter="rechnen"
            />
          </div>

          <div class="inputItem px-0 mt-5">
            <button class="clear mb-5" @click="rechnen">
              Calculate
            </button>
          </div>
        </div>
      </div>

      <div v-if="showResult">
        <div class="clear">
          <table class="tbl" m-0 p-0>
            <tr class="border-bottom mb-2">
              <td class=""></td>
              <td class="text-left font-weight-bold mt-3 px-0">
                <b class="">No optimisation </b>
              </td>
              <td class="text-left font-weight-bold mt-3"><b>DEIN RAUM</b></td>
            </tr>
            <tr class="border-bottom">
              <td class="head pl-5 px-0">Employees per workstation</td>
              <td class="mx-4 pl-3">{{ proArbeitplatz }}</td>
              <td class="pl-3">{{ proArbeitplatzDeinRaum }}</td>
            </tr>
            <tr class="border-bottom">
              <td class="head px-0">Office space needed</td>
              <td>{{ benoetigteFleache }}</td>
              <td>{{ beneotigteFleacheDeinRaum }}</td>
            </tr>
            <tr class="border-bottom my-2">
              <!--201A15 io30 - und Meetingsraumsuche-->
              <td class="head">
                Workplace and meeting room search costs (per month)
              </td>
              <td>{{ kostenProPlatz }}</td>
              <td>{{ kostenDeinRaum }}</td>
            </tr>
            <tr class="border-bottom">
              <td class="head">Costs per year</td>
              <td>{{ kostenProJahr }}</td>
              <td>{{ kostenProJahrDeinRaum }}</td>
            </tr>
            <tr class="border-bottom">
              <td class="head px-0"><b>Savings per year</b></td>
              <td>
                <b class="pl-3">{{ einsparung }}</b>
              </td>
              <td>
                <b class="pl-5"
                  >{{ einsparungDeinRaum }} ({{ procentDeinRaum }})</b
                >
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="line clear">
        <!--     <hr style="color:green" > -->
      </div>
      <p class="note clear">
        * 19,20 € is the average for German cities
      </p>
    </div>
    <div class="main-mobile show-on-mobile">
      <div>
        <p class="rechner_title">WHAT IS RESOURCE <br>OPTIMISATION ALL ABOUT?</p>
        <br />
        <p class="text-mobile">
          <b>DEIN RAUM</b> enables you to gain an insight into the utilisation of your workplaces and to realise potential savings through qualified analyses. With our savings calculator, you can quickly work out how much money your company can save with <b>DEIN RAUM</b>:
        </p>
        <div>
          <p class="warningMsg" v-if="showMessage">
            ** Please fill in all fields!
          </p>
        </div>
      </div>
      <div>
        <div class=" my-3">
          <label for="numemployee" class=" lbl-mobile "
            >Number of employees<sup>*</sup></label
          >
          <input
            style="width: 96%"
            id="numemployee"
            type="number"
            v-model="mitarbeiter"
            autofocus
          />
        </div>
        <div class=" my-3">
          <label for="fleache" class="lbl-mobile "
            >Office space in <b> m²</b></label
          >
          <input
            style="width: 96%"
            id="fleache"
            type="number"
            v-model="beurofleache"
          />
        </div>

        <div class=" my-3">
          <label for="kosten" class="lbl-mobile "
            >Costs per <b> m² </b>in <b>€</b><sup>*</sup></label
          >
          <input
            style="width: 96%"
            id="kosten"
            type="number"
            v-model="kosten"
          />
        </div>

        <div class="btn-mobile  mt-5">
          <button class="mb-5" @click="rechnen">
            Calculate
          </button>
        </div>
      </div>
      <div v-if="showResult">
        <div class="m-0 p-0 lo clear">
          <table class="tbl" m-0 p-0>
            <tr class="border-bottom mb-2">
              <td class="text-left font-weight-bold mt-3 px-0">
                <b class="">No optimisation </b>
              </td>
              <td class="text-left font-weight-bold mt-3"><b>DEIN RAUM</b></td>
            </tr>
            <tr>
              <td class="head-table-mobile">Employees per workstation</td>
            </tr>
            <tr class="border-bottom">
              <td class="mx-4 pl-3">{{ proArbeitplatz }}</td>
              <td class="pl-3">{{ proArbeitplatzDeinRaum }}</td>
            </tr>
            <tr>
              <td class="head-table-mobile ">Office space needed</td>
            </tr>
            <tr class="border-bottom">
              <td>{{ benoetigteFleache }}</td>
              <td>{{ beneotigteFleacheDeinRaum }}</td>
            </tr>
            <tr>
              <td class="head-table-mobile">
                Workplace and meeting room search costs (per month)
              </td>
            </tr>
            <tr class="border-bottom my-2">
              <td>{{ kostenProPlatz }}</td>
              <td>{{ kostenDeinRaum }}</td>
            </tr>
            <tr>
              <td class="head-table-mobile">Costs per year</td>
            </tr>
            <tr class="border-bottom">
              <td>{{ kostenProJahr }}</td>
              <td>{{ kostenProJahrDeinRaum }}</td>
            </tr>
            <tr>
              <td class="head-table-mobile"><b>Savings per year</b></td>
            </tr>
            <tr class="border-bottom">
              <td>
                <b class="pl-3">{{ einsparung }}</b>
              </td>
              <td>
                <b class="pl-5"
                  >{{ einsparungDeinRaum }} ({{ procentDeinRaum }})</b
                >
              </td>
            </tr>
          </table>
        </div>
      </div>
      <div class="line "></div>
      <p class="note ">
       * 19,20 € is the average for German cities
      </p>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      mitarbeiter: "",
      beurofleache: "",
      kosten: "",
      showResult: false,
      showMessage: false,
      windowWidth: window.innerWidth,
    };
  },

  methods: {
    rechnen() {
      if (
        this.mitarbeiter == "" ||
        this.beurofleache == "" ||
        this.kosten == ""
      ) {
        this.showMessage = true;
        this.showResult = false;
      } else {
        this.showResult = true;
        this.showMessage = false;
      }
    },
  },
  computed: {
    proArbeitplatz: function() {
      if (this.mitarbeiter == "" || this.beurofleache == "") return " ";
      return 1;
    },
    proArbeitplatzDeinRaum: function() {
      if (this.mitarbeiter == "") return " ";
      let nF = Intl.NumberFormat();
      return nF.format(1.4);
    },
    benoetigteFleache: function() {
      if (this.beurofleache == "") return " ";
      let nF = Intl.NumberFormat();
      return nF.format(Math.round(parseFloat(this.beurofleache))) + " m²";
    },
    beneotigteFleacheDeinRaum: function() {
      if (this.mitarbeiter == "") return " ";
      let nF = Intl.NumberFormat();
      return nF.format(Math.round(this.beurofleache / 1.4)) + " m²";
    },
    kostenProPlatz: function() {
      if (
        this.mitarbeiter == "" ||
        this.beurofleache == "" ||
        this.kosten == ""
      )
        return " ";
      return "/";
    },
    kostenDeinRaum: function() {
      if (
        this.mitarbeiter == "" ||
        this.beurofleache == "" ||
        this.kosten == ""
      )
        return " ";
      return parseFloat(this.mitarbeiter) * 1 + " €";
    },
    kostenProJahr: function() {
      if (
        this.mitarbeiter == "" ||
        this.beurofleache == "" ||
        this.kosten == ""
      )
        return " ";
      let nF = Intl.NumberFormat();

      return (
        nF.format(
          parseFloat(this.beurofleache) * parseFloat(this.kosten) * 12
        ) + " €"
      );
    },
    kostenProJahrDeinRaum: function() {
      if (
        this.mitarbeiter == "" ||
        this.beurofleache == "" ||
        this.kosten == ""
      )
        return " ";
      /*   let nF = Intl.NumberFormat();*/
      return (
        new Intl.NumberFormat("de-DE", { currency: "EUR" }).format(
          Math.round(
            (parseFloat(this.beneotigteFleacheDeinRaum) *
              parseFloat(this.kosten) +
              1 * this.mitarbeiter) *
              12
          )
        ) + " €"
      );
    },
    einsparung: function() {
      if (
        this.mitarbeiter == "" ||
        this.beurofleache == "" ||
        this.kosten == ""
      )
        return "0 €";
      return "0 €";
    },
    einsparungDeinRaum: function() {
      if (
        this.mitarbeiter == "" ||
        this.beurofleache == "" ||
        this.kosten == ""
      )
        return "0 €";

      /*      return Math.round(parseFloat(this.kostenProJahr) -  parseFloat(this.kostenProJahrDeinRaum))+ ' €'*/
      return (
        new Intl.NumberFormat("de-DE", { currency: "EUR" }).format(
          parseFloat(this.beurofleache) * parseFloat(this.kosten) * 12 -
            (
              Math.round(
                parseFloat(this.beneotigteFleacheDeinRaum) *
                  parseFloat(this.kosten) +
                  1 * this.mitarbeiter
              ) * 12
            ).toFixed(2)
        ) + " €"
      );
    },
    procentDeinRaum: function() {
      if (
        this.mitarbeiter == "" ||
        this.beurofleache == "" ||
        this.kosten == ""
      )
        return "0 %";
      let nF = Intl.NumberFormat();
      return (
        nF.format(
          (
            ((parseFloat(this.kostenProJahr) -
              parseFloat(this.kostenProJahrDeinRaum)) /
              parseFloat(this.kostenProJahr)) *
            100
          ).toFixed(2)
        ) + " %"
      );
    },
  },
};
</script>
<style scoped>
.main-mobile {
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: left;
}
.input-mobile {
  width: 100%;
  text-align: center;
}
.lbl-mobile {
  width: 100%;
}
.btn-mobile {
  display: flex;
  justify-content: center;
}
.head-table-mobile {
  text-align: left;
  width: 700px !important;
  margin: 0px 2px;
}
.lblMobile {
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: center;
  display: block;
  margin-top: 20px;
  width: 80%;
}
td {
  width: 250px;
  height: 40px;
}
.head {
  text-align: left;
  width: 750px;
}
.inputItem {
  overflow: hidden;
  white-space: nowrap;
  float: left;
  width: 240px;
  margin-left: 1px;
}
.clear {
  clear: both;
}
.main {
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: left;
}

span {
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: left;
}
.lbl {
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px;
  letter-spacing: 0px;
  text-align: left;
  display: block;
}
button {
  height: 51px;
  width: 165px;
  left: 910px;
  top: 2689px;
  border-radius: 0px;
  font-family: Poppins;
  font-size: 24px;
  font-style: normal;
  font-weight: 600;
  line-height: 48px;
  letter-spacing: 0px;
  text-align: center;
  left: 0%;
  right: -3.03%;
  top: 0%;
  bottom: 5.88%;
  background: #ffffff;
  border: 2px solid #212121;
  box-sizing: border-box;
  border-radius: 80px;
  padding: 0;
}
.warningMsg {
  color: red;
  text-align: left;
  font-size: small;
}

.note {
  text-align: left;
  font-size: 16px;
  color: black;
}
.rechner_title {
  font-family: Poppins;
  font-size: 32px;
  font-style: normal;
  font-weight: bold;
  line-height: 48px;
  letter-spacing: 0px;
  text-align: left;
  text-transform: uppercase;
}

@media screen and (min-width:992px) {
  .rechner_teaser{max-width:60%;}
}

span {
  font-size: 16px;
}
input[type="number"]::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
input[type="number"] {
  -moz-appearance: textfield;
  appearance: textfield;
  margin: 0;
  width: 170px;
  height: 68px;
  border: none;
  border-bottom: 2px solid black;
  font-family: Poppins;
  font-size: 36px;
  font-style: normal;
  font-weight: 600;
  line-height: 48px;
  letter-spacing: 0px;
  text-align: left;
  outline: none;
  background: transparent;
}

.inputMobile {
  -moz-appearance: textfield;
  appearance: textfield;
  margin: 0;
  width: 100%;
  height: 68px;
  border: none;
  border-bottom: 2px solid black;
  font-family: Poppins;
  font-size: 36px;
  font-style: normal;
  font-weight: 600;
  line-height: 48px;
  letter-spacing: 0px;
  text-align: left;
}
.line {
  width: 98%;
  height: 47px;
  margin: 1px;
  border-bottom: 3px solid black;
  margin-bottom: 20px;
}
.show-on-mobile {
  text-align: left;
}
@media (min-width: 521px) {
  .show-on-mobile {
    display: none !important;
  }
}
@media (max-width: 520px) {
  .show-on-desktop {
    display: none !important;
  }
}
.px-0 {
  padding-right: 0 !important;
  padding-left: 0 !important;
}
.my-4 {
    margin-top: 1.5rem !important;
    margin-bottom: 1.5rem !important;
}
.my-2 {
    margin-top: 0.5rem !important;
    margin-bottom: 0.5rem !important;
}
.mb-5 {
    margin-bottom: 3rem !important;
}
.justify-content-center {
    justify-content: center !important;
}
table {
    caption-side: bottom;
    border-collapse: collapse;
    border: none;
}
thead, tbody, tfoot, tr, td, th {
    border-color: inherit;
    border-style: solid;
    border-width: 0;
}
.mt-3 {
    margin-top: 1rem !important;
}
.mt-5 {
    margin-top: 3rem !important;
}
.mb-2 {
    margin-bottom: 0.5rem !important;
}
.border-bottom {
    border-bottom: 1px solid #dee2e6 !important;
}
</style>
